'use client';

import dynamic from 'next/dynamic';
import SearchToAccessHelperCenter from './SearchToAccessHelperCenter/SearchToAccessHelperCenter';

const SearchCertificate = dynamic(() => import('./SearchCertificate/SearchCertificate'), { ssr: false });

function calculateLevenshteinDistance(firstWord: string, secondWord: string) {
  const matrix = Array.from({ length: firstWord.length + 1 }, (_, i) => Array.from({ length: secondWord.length + 1 }, (_, j) => (i === 0 ? j : i)));

  for (let i = 1; i <= firstWord.length; i += 1) {
    for (let j = 1; j <= secondWord.length; j += 1) {
      if (firstWord[i - 1] === secondWord[j - 1]) {
        matrix[i][j] = matrix[i - 1][j - 1];
      } else {
        matrix[i][j] = Math.min(matrix[i - 1][j] + 1, matrix[i][j - 1] + 1, matrix[i - 1][j - 1] + 1);
      }
    }
  }

  return matrix[firstWord.length][secondWord.length];
}

function calculateSimilarity(firstWord: string, secondWord: string): number {
  const distance = calculateLevenshteinDistance(firstWord, secondWord);
  const maxLength = Math.max(firstWord.length, secondWord.length);

  if (maxLength === 0) {
    return 100;
  }

  return (1 - distance / maxLength) * 100;
}

const searchSpecificTerms = [
  {
    searchTerms: ['certificado'],
    label: 'certificado',
    Component: SearchCertificate,
    link: '',
  },
  {
    searchTerms: ['cancelamento', 'cancelar'],
    label: 'cancelamento de ingresso',
    Component: SearchToAccessHelperCenter,
    link: 'https://ajuda.sympla.com.br/hc/pt-br/sections/360000213506-Cancelamento-e-reembolso',
  },
  {
    searchTerms: ['reembolso', 'reembolsar'],
    label: 'reembolso',
    Component: SearchToAccessHelperCenter,
    link: 'https://ajuda.sympla.com.br/hc/pt-br/sections/360000213506-Cancelamento-e-reembolso',
  },
];

const checkSimilarityWords = (term: string, word: string) => {
  if (term.toLowerCase().includes(word.toLowerCase())) return true;

  const threshold = 70;
  return calculateSimilarity(term.toLowerCase(), word.toLowerCase()) > threshold;
};

function getSearchSpecificTerms(term: string) {
  const matchingTerm = searchSpecificTerms.find(({ searchTerms }) => searchTerms.some((word) => checkSimilarityWords(term, word)));

  if (matchingTerm) {
    const { Component, link, label } = matchingTerm;
    return <Component link={link} term={label} />;
  }

  return null;
}

export default getSearchSpecificTerms;
